import { OperatingHours } from '@leverege/operating-hours'
import { useSharedContext } from '@leverege/ui-plugin'
import { useCallback, useMemo, useRef } from 'react'

const EMPTY_ARRAY = []

export default function useStoreTrafficEvents( props ) {
  const { result } = props
  const { operatingHours } = useSharedContext()
  const isOpenCache = useRef( {} )
  const isOpen = useCallback( ( evt ) => {
    const [ date, time ] = evt.time.split( 'T' )
    const hour = time.substring( 0, 2 )
    const key = `${date}T${hour}`

    if ( isOpenCache.current[key] ) {
      return isOpenCache.current[key]
    }

    const open = OperatingHours.getIsOpen( operatingHours, new Date( evt.time ) )
    isOpenCache.current[key] = open

    return open
  }, [ operatingHours ] )

  const events = useMemo( () => {
    if ( !result?.items ) {
      return EMPTY_ARRAY
    }
    const ret = []

    for ( let i = 0; i < result.items.length; i++ ) {
      const cEvent = result.items[i]
      const pCount = cEvent?.data?.data?.changes?.person
      const dCount = cEvent?.data?.data?.changes?.dog

      if ( pCount != null ) {
        if ( isOpen( cEvent ) ) {
          ret.push( constructEvent( cEvent, 'person' ) )
        }
      }

      if ( dCount != null ) {
        if ( isOpen( cEvent ) ) {
          ret.push( constructEvent( cEvent, 'dog' ) )
        }
      }
    }

    return ret
  }, [ result?.items, isOpen ] )

  return {
    result : {
      ...props.result,
      items : events
    }
  }
}

function constructEvent( event, type ) {
  return {
    ...event,
    data : {
      ...event.data,
      data : {
        ...event.data.data,
        counts : {
          [type] : event.data.data.counts[type]
        }
      }
    }
  }
}
